import withClasificacionDocente from "../../hoc/Docentes/withClasifiacionDocente";
import ListaClasificacion from "../../view/components/RegistroUsuarios/Clasificacion/VistaClasificacion/ListaClasificacion";

export default withClasificacionDocente(ListaClasificacion);